import {
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  TextField,
} from '@mui/material'
import Header from 'components/Header'
import { useBasePath } from 'components/Providers'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { save, search } from 'store/visitor-log'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

export default function VisitorCheckoutForm({ visitorLog }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const basePath = useBasePath()

  const [checkOutAt, setCheckOutAt] = useState(dayjs())
  const [checkOutNote, setCheckOutNote] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    const payload = {
      id: visitorLog.id,
      checkOutAt: checkOutAt.toISOString(),
      note: checkOutNote
        ? `${visitorLog.note || ''} - Check-Out Note: ${checkOutNote}`
        : visitorLog.note,
    }

    setSaving(true)

    const res = await dispatch(save(payload))

    setSaving(false)

    if (res.payload) {
      dispatch(
        search({
          date: dayjs().format('YYYY-MM-DD'),
        }),
      )

      navigate(basePath)
    }
  }

  return (
    <Card
      elevation={0}
      sx={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header
        title={t('Check Out Visitor')}
        small
        close
        borderBottom
        onClose={() => navigate(basePath)}
      />

      <CardContent sx={{ flexGrow: 1 }}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            size="small"
            label={t('Visitor')}
            value={`${visitorLog?.visitorFirstName || ''} ${
              visitorLog?.visitorLastName || ''
            }`.trim()}
            InputProps={{
              readOnly: true,
            }}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label={t('Check-Out Time')}
              value={checkOutAt}
              onChange={value => setCheckOutAt(value)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                },
              }}
            />
          </LocalizationProvider>

          <TextField
            fullWidth
            multiline
            minRows={4}
            size="small"
            label={t('Check-Out Notes')}
            value={checkOutNote}
            onChange={event => setCheckOutNote(event.target.value)}
          />
        </Stack>
      </CardContent>

      <CardActions
        sx={{
          justifyContent: 'flex-end',
          p: 2,
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Button
          variant="outlined"
          onClick={() => navigate(basePath)}
        >
          {t('Cancel')}
        </Button>

        <Button
          variant="contained"
          disabled={!checkOutAt || saving}
          onClick={handleSave}
        >
          {saving ? t('Saving...') : t('Save')}
        </Button>
      </CardActions>
    </Card>
  )
}